/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import useTEItem from '@/hooks/Dashoboard/Members/Profile/TrainingExperiences/useTEItem'
import {
  TrainingExperience,
} from '@/types/graphql/types'
import { ActionIcon, Loader, Text, useMantineTheme } from '@mantine/core'
import classNames from 'classnames'
import { MdDeleteOutline } from 'react-icons/md'
import { Edit } from 'tabler-icons-react'

const TEItem = ({
  item,
  handleUpdate,
}: {
  item: TrainingExperience
  handleUpdate: ({ newTE }: { newTE: TrainingExperience[] }) => void
}) => {
  const { colorScheme } = useMantineTheme()
  const isDark = colorScheme === 'dark' 
  const { openDeleteMessage, openTrainingExperience,loading } = useTEItem({
    item,
    handleUpdate,
  })

  return (
    <div
      className={classNames(
        'border rounded-lg p-3 my-3 border-opacity-20 w-full flex',
        isDark ? 'border-gray-200' : 'border-gray-900',
      )}
    >
      <div className="flex-auto">
        <Text size="lg" weight="bold">
          {item.eventName}
        </Text>
        <Text>{item.executingAgency}</Text>
      </div>
      <div>
        <ActionIcon
          variant="default"
          onClick={() => openTrainingExperience(item)}
          mb={5}
        >
          <Edit size={16} />
        </ActionIcon>
        <ActionIcon
          variant="default"
          onClick={() => openDeleteMessage(item.id)}
        >
          {loading ? <Loader size="xs" /> : <MdDeleteOutline size={16} />}
        </ActionIcon>
      </div>
    </div>
  )
}
export default TEItem
